<template lang="pug">
MarkupForm(
  button-text='Восстановить <nobr>мой пароль</nobr>',
  :disabled='isDisabled || !$v.email.isUserFriendlyEmail',
  :hide-button='hasMessage',
  :messages='message',
  @submit='onSubmit'
)
  FormInput.field(
    v-model.trim='email',
    label='Введите Ваш email',
    name='email',
    placeholder='Например, mail@mail.ru'
    :disabled='isDisabled',
    :error='validStateMachine($v.email.$dirty, $v.email.$invalid)',
    :error-text='(() => (typeof getMessage($v.email) == "string" ? getMessage($v.email) : getMessage($v.email)(email)))()',
    @focus='$v.email.$reset()',
    @input='$v.email.$reset()',
    @blur='$v.email.$touch()'
  )
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { validationMixin, withParams } from 'vuelidate';
import { mailValidator, isUserFriendlyEmail, getMessage, validStateMachine } from "@/tools/validators";

import { ACTIONS } from '@/store/user';

import {
  VARIANT_SUCCESS,
  VARIANT_ERROR,
} from '@/components/markup/popup/form/notification';
import { Input as FormInput } from '@/components/form';
import MarkupForm from '@/components/markup/popup/form';

import { get } from 'lodash';

const { mapActions } = createNamespacedHelpers('user');

const STATUS_READY = 'ready';
const STATUS_WAIT = 'wait';
const STATUS_SUCCESS = 'success';

export default {
  name: 'ViewDefaultPopupFormForget',

  components: {
    FormInput,
    MarkupForm,
  },

  mixins: [validationMixin],

  data() {
    return {
      email: '',
      error: false,
      message: null,
      status: STATUS_READY,
    };
  },

  validations() {
    const problemEmails =
      this.$store.state.regionProfile.constants.problem_email_domains;
    const getMessageByInsertedEmail = (value) => {
      if (value) {
        return value.replace(/.*@/, '');
      } else {
        return '';
      }
    };
    return {
      email: {
        mailValidator: withParams(
          { $message: 'Укажите корректный email' },
          mailValidator
        ),
        isUserFriendlyEmail: withParams(
          {
            $message: (value) =>
              `Внимание! Уведомления не направляются на адреса с доменом ${getMessageByInsertedEmail(
                value
              )}. Обратитесь в учреждение ДО для смены e-mail.`,
          },
          isUserFriendlyEmail(problemEmails)
        ),
      },
    };
  },

  computed: {
    isDisabled() {
      return this.status !== STATUS_READY;
    },
    hasMessage() {
      return this.message && this.message.length > 0;
    },
  },

  methods: {
    ...mapActions({ sendForget: ACTIONS.FORGET }),
    validStateMachine: validStateMachine,
    getMessage: getMessage,
    async onSubmit() {
      try {
        const { $v, email } = this;

        $v.$touch();
        if ($v.$invalid) {
          this.error = true;
          return;
        }

        this.status = STATUS_WAIT;
        await this.sendForget(email);
        this.complete(
          VARIANT_SUCCESS,
          `Новый пароль будет отправлен на ваш электронный адрес <u>${email}</u>`
        );
      } catch ({ response }) {
        const message = get(response, 'data.errors.0.msg', null);
        const code = get(response, 'data.errors.0.code', null);
        if (code === 'DateResetPasswordException' && message) {
          this.complete(VARIANT_ERROR, message);
        } else {
          this.complete(
            VARIANT_ERROR,
            'Во время отправки запроса произошла ошибка'
          );
        }
      }
    },

    complete(variant, content) {
      this.error = false;
      this.status = STATUS_SUCCESS;
      this.message = [
        {
          variant,
          items: {
            content,
            strong: true,
          },
        },
      ];
    },
  },
};
</script>



// WEBPACK FOOTER //
// ViewDefaultPopupFormForget.vue?1ac5a3e4